module.exports = __webpack_public_path__ + "img/pantalla-2-7.be54af08.png";